import React from 'react';

import { isTruss, MovingLoadSettings } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';
import { InlineNotification } from '@paragon/notification-tools';

import { editMovingLoadInComponentDesign } from '../../../../store/actions/editAdditionalLoadingActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { inViewOnlyMode } from '../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { MovingLoadProperties } from './MovingLoadProperties';

interface Props {
  movingLoadSettings: MovingLoadSettings;
}

export function MovingLoadSettingsEdit(props: Props) {
  const dispatch = useAppDispatch();
  const componentDesign = useAppSelector(getActiveComponentDesign);
  const isViewOnly = useAppSelector(inViewOnlyMode);

  if (!componentDesign) return <InlineNotification type="error">No active component</InlineNotification>;

  const { component } = componentDesign;
  if (!isTruss(component)) return <InlineNotification type="error">Component is not a truss</InlineNotification>;

  return (
    <PropertiesPanel title="Moving Load Properties">
      <MovingLoadProperties
        movingLoadSettings={props.movingLoadSettings}
        trussSpacing={component.spacing}
        onChange={(newMovingLoadSettings) =>
          dispatch(editMovingLoadInComponentDesign(componentDesign, newMovingLoadSettings))
        }
        disabled={isViewOnly}
      />
    </PropertiesPanel>
  );
}
